<template>
  <div class="page-content" id="profile-list">
    <Titlebar :incrustation="'fa-cogs'">
      <h1>{{ $t("news.title") }}</h1>
    </Titlebar>
    <div>
      <div v-if="newsItems === undefined" class="news-container-list">
        <lottie-player
          src="/static/animations/newspaper.json"
          mode="bounce"
          foreground="#666666"
          background="#FFFFFF"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </div>
      <div
        v-if="
          newsItems !== undefined &&
          Array.isArray(newsItems) &&
          newsItems.length === 0
        "
        class="news-container-list"
      >
        <p class="empty-set">{{ $t("news.nonews") }}</p>
      </div>
      <div
        v-if="
          newsItems !== undefined &&
          Array.isArray(newsItems) &&
          newsItems.length > 0
        "
        class="news-container-list"
      >
        <UiCard v-for="item in newsItems" class="news-item mb-4" :key="item.id">
          <article>
            <header class="news-item-header mb-4">
              <h4 class="text-2xl mb-3">
                {{ item.title.replace("Edition", "Édition") }}
              </h4>
              <div class="text-sm">
                <span
                  v-if="item.type"
                  class="news-item-type mr-2"
                  :class="[
                    item.type === 'beta' ? 'beta' : '',
                    item.type === 'new' ? 'new' : '',
                    item.type === 'astuce' ? 'astuce' : '',
                    item.type === 'info' ? 'info' : '',
                  ]"
                  >{{ item.type }}</span
                >
                <span class="text-gray-400 font-medium uppercase">{{
                  getDisplayDate(item)
                }}</span>
              </div>
            </header>
            <div
              class="news-item-content prose"
              v-html="item.content.replace('Edition', 'Édition')"
            ></div>
          </article>
        </UiCard>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/fr";
import axios from "axios";
import API from "@/services/API.js";
import Titlebar from "@/components/ui/Titlebar";
import UiCard from "@/components/ui/Card";

export default {
  name: "News",
  components: {
    Titlebar,
    UiCard,
  },
  props: {},
  data() {
    return {
      newsItems: undefined,
    };
  },
  mounted() {
    if (
      process.env.APP_ENV !== "production" &&
      process.env.APP_ENV !== "master"
    ) {
      this.newsItems = [];
      return;
    }

    if (this.newsItems === undefined) {
      axios
        .get(API.endpoints.news.list)
        .then((response) => {
          this.newsItems = response.data;
        })
        .catch(() => {
          this.newsItems = [];
        });
    }
  },
  methods: {
    getDisplayDate: function (item) {
      moment.locale(window.V.$i18n.locale);
      return moment(item.date).format("D MMMM YYYY");
    },
  },
};
</script>

<style lang="scss">
.news-container-list {
  overflow: auto;
  height: 100%;

  .news-item {
    max-width: 80ch;
    margin-inline: auto;

    .news-item-header {
      .news-item-type {
        display: inline-block;
        letter-spacing: 0.025em;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 0.75rem;
        line-height: 1rem;
        padding: 0.125rem 0.375rem;
        border-radius: 0.375rem;
        border: 1px solid;
      }

      .news-item-type.new,
      .news-item-type.beta {
        color: #3b82f6;
        background-color: #eff6ff;
      }
      .news-item-type.astuce {
        color: #22c55e;
        background-color: #f0fdf4;
      }
      .news-item-type.info {
        color: #ec4899;
        background-color: #fdf2f8;
      }
    }

    .news-item-content {
      overflow: hidden;

      img {
        width: 100%;
        border: none;
        height: auto;
      }

      iframe {
        width: 100%;
        border: none;
      }

      a {
        color: #3b82f6;
        text-decoration: underline;
      }
      u,
      [style="text-decoration: underline;"] {
        text-decoration: unset !important;
      }
    }
  }
}
</style>
